import React from "react";
import HeadingWithLine from "../../../../../components/HeadingWithLine/HeadingWithLine";
import { getPricingName, getPricingDataById } from "../../../../../../components/helper/helper";

function Tiered({ appData }) {
  return (
    <>
      <ul>
        <li>
          <div>
            <p>Pricing model</p>
            <p>{getPricingName(appData.qualifiedtype)}</p>
          </div>
        </li>
        {appData?.qualifiedtype === "tiered" && appData?.tiered_type && (
          <li>
            <div>
              <p>Tiered Pricing Type</p>
              <p style={{ textTransform: "capitalize" }}>{appData.tiered_type}</p>
            </div>
          </li>
        )}
      </ul>

      <div>
        <HeadingWithLine text="Qualified" />
        <ul>
          <li>
            <div>
              <p>Qual Rate</p>
              <p>{getPricingDataById(appData, 1).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Qual Txn Fee</p>
              <p>$ {getPricingDataById(appData, 1).dollars}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Qual Debit Rate</p>
              <p>{getPricingDataById(appData, 39).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Qual Debit Txn Fee</p>
              <p>$ {getPricingDataById(appData, 39).dollars}</p>
            </div>
          </li>
        </ul>
      </div>

      <div>
        <HeadingWithLine text="Mid - Qualified" />
        <ul>
          <li>
            <div>
              <p>Mid Qual Rate</p>
              <p>{getPricingDataById(appData, 3).percent != null && getPricingDataById(appData, 3).percent !== "" ? `${getPricingDataById(appData, 3).percent}%` : "-"}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Mid Qual Txn Fee</p>
              <p>{getPricingDataById(appData, 3).dollars != null && getPricingDataById(appData, 3).dollars !== "" ? `$ ${getPricingDataById(appData, 3).dollars}` : "-"}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Mid Qual Debit Rate</p>
              <p>{getPricingDataById(appData, 40).percent != null && getPricingDataById(appData, 40).percent !== "" ? `${getPricingDataById(appData, 40).percent}%` : "-"}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Mid Qual Debit Txn Fee</p>
              <p>{getPricingDataById(appData, 40).dollars != null && getPricingDataById(appData, 40).dollars !== "" ? `$ ${getPricingDataById(appData, 40).dollars}` : "-"}</p>
            </div>
          </li>
        </ul>
      </div>

      <div>
        <HeadingWithLine text="Non - Qualified" />
        <ul>
          <li>
            <div>
              <p>Non Qual Rate</p>
              <p>{getPricingDataById(appData, 4).percent != null && getPricingDataById(appData, 4).percent !== "" ? `${getPricingDataById(appData, 4).percent}%` : "-"}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Non Qual Txn Fee</p>
              <p>{getPricingDataById(appData, 4).dollars != null && getPricingDataById(appData, 4).dollars !== "" ? `$ ${getPricingDataById(appData, 4).dollars}` : "-"}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Non Qual Debit Rate</p>
              <p>{getPricingDataById(appData, 41).percent != null && getPricingDataById(appData, 41).percent !== "" ? `${getPricingDataById(appData, 41).percent}%` : "-"}</p>
            </div>
          </li>
          <li>
            <div>
              <p>Non Qual Debit Txn Fee</p>
              <p>{getPricingDataById(appData, 41).dollars != null && getPricingDataById(appData, 41).dollars !== "" ? `$ ${getPricingDataById(appData, 41).dollars}` : "-"}</p>
            </div>
          </li>
        </ul>
      </div>

      {/* Pin Based Debit */}
      <div>
        <HeadingWithLine text={`Pin-Based Debit${appData?.billing?.network_fee === "no" ? " (Disabled)" : ""}`} />
        <ul>
          <li>
            <div>
              <p>Network Fee</p>
              <p>{appData?.billing?.network_fee == 'yes' ? "Yes" : "No"}</p>
            </div>
          </li>
        </ul>
        <ul>
          <li>
            <div>
              <p>Debit Rate</p>
              <p>{getPricingDataById(appData, 5).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Per Transaction</p>
              <p>$ {getPricingDataById(appData, 5).dollars}</p>
            </div>
          </li>
        </ul>
      </div>
      {/* Debit Structure */}
      <div>
        <HeadingWithLine text="AMEX Structure" />
        <ul>
          <li>
            <div>
              <p>Debit Structure</p>
              <p>{appData.pricing_model !== null && appData.pricing_model !== "" ? getPricingName(appData.pricing_model) : "AMEX Pricing disabled"}</p>
            </div>
          </li>
        </ul>
      </div>

      {appData.pricing_model == "tiered" && (
        <div>
          <ul>
            <li>
              <div>
                <p>AMEX Tier 1</p>
                <p>{getPricingDataById(appData, 32).percent}%</p>
              </div>
            </li>
            <li>
              <div>
                <p>AMEX Tier 1 Txn Fee</p>
                <p>$ {getPricingDataById(appData, 32).dollars}</p>
              </div>
            </li>
            <li>
              <div>
                <p>AMEX Tier 2</p>
                <p>{getPricingDataById(appData, 33).percent != null && getPricingDataById(appData, 33).percent !== "" ? `${getPricingDataById(appData, 33).percent}%` : "-"}</p>
              </div>
            </li>
            <li>
              <div>
                <p>AMEX Tier 2 Txn Fee</p>
                <p>{getPricingDataById(appData, 33).dollars != null && getPricingDataById(appData, 33).dollars !== "" ? `$ ${getPricingDataById(appData, 33).dollars}` : "-"}</p>
              </div>
            </li>
            <li>
              <div>
                <p>AMEX Tier 3</p>
                <p>{getPricingDataById(appData, 34).percent != null && getPricingDataById(appData, 34).percent !== "" ? `${getPricingDataById(appData, 34).percent}%` : "-"}</p>
              </div>
            </li>
            <li>
              <div>
                <p>AMEX Tier 3 Txn Fee</p>
                <p>{getPricingDataById(appData, 34).dollars != null && getPricingDataById(appData, 34).dollars !== "" ? `$ ${getPricingDataById(appData, 34).dollars}` : "-"}</p>
              </div>
            </li>
            <li>
              <div>
                <p>AMEX Tier 4</p>
                <p>{getPricingDataById(appData, 49).percent != null && getPricingDataById(appData, 49).percent !== "" ? `${getPricingDataById(appData, 49).percent}%` : "-"}</p>
              </div>
            </li>
            <li>
              <div>
                <p>AMEX Tier 4 Txn Fee</p>
                <p>{getPricingDataById(appData, 49).dollars != null && getPricingDataById(appData, 49).dollars !== "" ? `$ ${getPricingDataById(appData, 49).dollars}` : "-"}</p>
              </div>
            </li>
          </ul>
        </div>
      )}

      {appData.pricing_model == "flat_rate" && (
        <div>
          <ul>
            <li>
              <div>
                <p>
                  {" "}
                  AMEX Flat Rate
                </p>
                <p>{getPricingDataById(appData, 35).percent}%</p>
              </div>
            </li>
            <li>
              <div>
                <p>AMEX Flat Rate Txn Fee</p>
                <p>$ {getPricingDataById(appData, 35).dollars}</p>
              </div>
            </li>
          </ul>
        </div>
      )}

      {appData.pricing_model == "ic_plus" && (
        <div>
          <ul>
            <li>
              <div>
                <p>
                  {" "}
                  AMEX IC+ Rate
                </p>
                <p>{getPricingDataById(appData, 35).percent}%</p>
              </div>
            </li>
            <li>
              <div>
                <p>AMEX IC+ Txn Fee</p>
                <p>$ {getPricingDataById(appData, 35).dollars}</p>
              </div>
            </li>
          </ul>
        </div>
      )}

    </>
  );
}

export default Tiered;
